import axiosInstance from "../../utils/axiosInstance";
import { getAuthHeaders } from "../../utils/authHeader";

const Base_URL = `/tasks`;

export const createTaskForMeetingApi = async (meetingData, meetingId) => {
  const res = await axiosInstance.put(
    `${Base_URL}/${meetingId}`,
    meetingData,
    getAuthHeaders(),
  );
  return res.data;
};

export const updateTaskApi = async (payload) => {
  const res = await axiosInstance.put(
    `${Base_URL}/update`,
    payload,
    getAuthHeaders(),
  );
  return res.data;
};

export const getTaskApi = async (meetingId) => {
  const res = await axiosInstance.get(
    `${Base_URL}/${meetingId}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const deleteTaskApi = async ({ taskId, meetingId }) => {
  const res = await axiosInstance.put(
    `${Base_URL}/delete`,
    { taskId, meetingId },
    getAuthHeaders(),
  );
  return res.data;
};

export const executeTaskApi = async (taskData, meetingId, timeZone) => {
  const res = await axiosInstance.post(
    `${Base_URL}/execute`,
    { taskData, meetingId },
    getAuthHeaders(),
  );
  return res.data;
};

export const generateTaskApi = async (meetingId, prompt, agentId) => {
  const res = await axiosInstance.post(
    `${Base_URL}/generate/${meetingId}`,
    { prompt, agentId },
    getAuthHeaders(),
  );
  return res.data;
};

export const getTaskOptionsApi = async (settingId, platformType, meetingId) => {
  const res = await axiosInstance.post(
    `${Base_URL}/options`,
    {
      settingId,
      platformType,
      meetingId
    },
    getAuthHeaders(),
  );

  return res.data;
};
